import { ActivityLogsData } from 'store/reducers/activity-log/get-activity-logs/types';

export const GET_LODGING_OPTION_ACTIVITY_LOGS_REQUEST = 'GET_LODGING_OPTION_ACTIVITY_LOGS_REQUEST';
export const GET_LODGING_OPTION_ACTIVITY_LOGS_SUCCESS = 'GET_LODGING_OPTION_ACTIVITY_LOGS_SUCCESS';
export const GET_LODGING_OPTION_ACTIVITY_LOGS_FAILURE = 'GET_LODGING_OPTION_ACTIVITY_LOGS_FAILURE';

interface GetActivityLogsRequest {
  type: typeof GET_LODGING_OPTION_ACTIVITY_LOGS_REQUEST;
};

interface GetActivityLogsSuccess {
  type: typeof GET_LODGING_OPTION_ACTIVITY_LOGS_SUCCESS;
  contents: ActivityLogsData;
}

interface GetActivityLogsFailure {
  type: typeof GET_LODGING_OPTION_ACTIVITY_LOGS_FAILURE;
}

export type GetActivityLogsActionTypes = GetActivityLogsRequest | GetActivityLogsSuccess | GetActivityLogsFailure;
